export const PhoneFrame = ({ children, className = "" }) => (
  <div
    className={`relative w-[230px] h-[470px] rounded-[32px] bg-[#141416] border-[6px] border-[#232326] shadow-2xl overflow-hidden flex-shrink-0 ${className}`}
  >
    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-4 bg-[#0A0A0B] rounded-b-2xl z-20" />
    <div className="w-full h-full overflow-hidden">{children}</div>
  </div>
);
